export const API_BASE_URL = `${process.env.REACT_APP_BASE_URL}/api`;

export const SSE_BASE_URL = `${process.env.REACT_APP_BASE_URL}/sse`;
